import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomDataService } from '../services/custom-data.service';
import { MoviesService } from '../services/movies.service';
import * as $ from "jquery"

@Component({
  selector: 'app-type-movie',
  templateUrl: './type-movie.component.html',
  styleUrls: ['./type-movie.component.css']
})
export class TypeMovieComponent implements OnInit {

  myMovie ; type  ; searchedMovie:any[]
  constructor(private _router:Router , private _activatedroute:ActivatedRoute , private allMovies:MoviesService) 
  { 
    this._activatedroute.params.subscribe(params => {
      this.type = params['type'];
      // reset and set based on new parameter this time
      this.searchedMovie = []
      this.myMovie = this.allMovies.movies ; 
      });
      for(let item of this.myMovie)
      {
        for(let type of item.type)
        {
          if (type === this.type)
          {
            this.searchedMovie.push(item)
          }
        }
      }
  }

  ngOnInit() {
    this._activatedroute.params.subscribe(params => {
      this.type = params['type'];
      // reset and set based on new parameter this time
      this.searchedMovie = []
      this.myMovie = this.allMovies.movies ; 
      for(let item of this.myMovie)
      {
        for(let type of item.type)
        {
          if (type === this.type)
          {
            this.searchedMovie.push(item)
          }
        }
      }
      });
      
      $(document).ready(function(){
        $("body").on("click",".accor li",function(){
          if($(this).attr("id") == "1")
          {
           $(".firs").css("display","block");
            $(".sec").css("display","none");  
             $(this).addClass("act");
             $(this).siblings().removeClass("act"); 
            
        
          
          }
          else
          {
            
            $(".sec").css("display","block");
            $(".firs").css("display","none"); 
            $(this).addClass("act");
             $(this).siblings().removeClass("act"); 
          
          }
        });

        });
     
  }
  search()
  {
    var searchValue = (<HTMLInputElement>document.getElementById('searchValue')).value ; 
    (<HTMLInputElement>document.getElementById('searchValue')).value = ""
    this._router.navigate(["/Movie/Search",searchValue.toUpperCase()]);

  }
  goToType(type)
  {
    this._router.navigate(["/Movie/Type",type.toUpperCase()]);
  }
  goToDetails(id)
 {
  this._router.navigate(["/Movie/Details",id]);
 }
}
